import { Navigate } from "react-router-dom";
import { SIGN_IN } from "../../resources/links";
import { ReactNode, useEffect } from "react";
import useUserAccount from "../../hooks/stateHooks/userAccountHook";

const OnboardingGuard = ({ children }: { children: ReactNode }) => {
    const { getAccount, IS_ACTIVATED, IS_ONBOARDED } = useUserAccount();

    if (!getAccount().isAuthenticated) {
        return <Navigate to={`/auth/${SIGN_IN}`} replace />;
    }

    if (!IS_ACTIVATED) {
        return <Navigate to={`/onboarding/user`} replace />;
    }

    if (!IS_ONBOARDED) {
        return <Navigate to={`/onboarding/company`} replace />;
    }

    return <>{children}</>;
};

export default OnboardingGuard;